<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            role="tab"
            data-toggle="tab"
            class="nav-link"
            @click.prevent="setActive('#t1' + rowData.docfisId + '')"
            :class="{ active: isActive('#t1' + rowData.docfisId + '') }"
            v-bind:href="'#t1' + rowData.docfisId + ''"
            >Partes envolvidas</a
          >
        </li>
        <li class="nav-item">
          <a
            role="tab"
            data-toggle="tab"
            class="nav-link"
            @click.prevent="setActive('#t2' + rowData.docfisId + '')"
            :class="{ active: isActive('#t2' + rowData.docfisId + '') }"
            v-bind:href="'#t2' + rowData.docfisId + ''"
            >Itens</a
          >
        </li>
        <li class="nav-item">
          <a
            role="tab"
            data-toggle="tab"
            class="nav-link"
            @click.prevent="setActive('#t4' + rowData.docfisId + '')"
            :class="{ active: isActive('#t4' + rowData.docfisId + '') }"
            v-bind:href="'#t4' + rowData.docfisId + ''"
            v-if="
              rowData.cargaBipDoc != null &&
              rowData.cargaBipDoc.carga != null &&
              rowData.cargaBipDoc.carga.obs != null
            "
            >Observação</a
          >
        </li>
        <li class="nav-item" v-if="rowData.docFiscalUnidade.length > 0">
          <a
            role="tab"
            data-toggle="tab"
            class="nav-link"
            @click.prevent="setActive('#t3' + rowData.docfisId + '')"
            :class="{ active: isActive('#t3' + rowData.docfisId + '') }"
            v-bind:href="'#t3' + rowData.docfisId + ''"
            >Unidades</a
          >
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          :class="{ 'active show': isActive('#t1' + rowData.docfisId + '') }"
          v-bind:id="'#t1' + rowData.docfisId + ''"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 10%">
                  <a
                    v-if="getPermission('montagemcarga.update')"
                    @click="onEditaPartesEnv(rowData.DocFiscalPartesEnv)"
                    v-b-tooltip
                    title="Editar"
                    ><i class="fa fa-edit"></i
                  ></a>
                </th>
                <th data-toggle="true" style="width: 10%">CNPJ / CPF</th>
                <th data-toggle="true" style="width: 10%">IE</th>
                <th data-toggle="true" style="width: 10%">Nome</th>
                <th data-toggle="true" style="width: 10%">Município</th>
                <th data-toggle="true" style="width: 3%">Estado</th>
                <th data-toggle="true" style="width: 15%">Endereço</th>
                <th data-toggle="true" style="width: 12%">Bairro</th>
                <th data-toggle="true" style="width: 10%">CEP</th>
                <th data-toggle="true" style="width: 10%">Email</th>
                <th data-toggle="true" style="width: 5%">Telefone</th>
                <th data-toggle="true" style="width: 5%">Ações</th>
              </tr>
            </thead>

            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-primary">Emitente</span>
                </td>
                <td>
                  <span v-if="rowData.DocFiscalPartesEnv.emiCnpj != null">{{
                    ajustaMascara(rowData.DocFiscalPartesEnv.emiCnpj)
                  }}</span>
                  <span v-if="rowData.DocFiscalPartesEnv.emiCpf != null">{{
                    ajustaMascara(rowData.DocFiscalPartesEnv.emiCpf)
                  }}</span>
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.emiIe }}
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.emiNome }}
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.emiNomeMunicipio }}
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.emiUf }}
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.emiEndereco }} -
                  {{ rowData.DocFiscalPartesEnv.emiComplemento }} -
                  {{ rowData.DocFiscalPartesEnv.emiNumero }}
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.emiBairro }}
                </td>
                <td>
                  <span v-if="rowData.DocFiscalPartesEnv.emiCep">{{
                    rowData.DocFiscalPartesEnv.emiCep
                      .toString()
                      .padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.emiEmail }}
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.emiTelefone }}
                </td>
                <td>
                  <a
                    v-if="
                      getPermission('montagemcarga.update') &&
                      rowData.cargaDoc &&
                      rowData.cargaDoc.docCargaDoc &&
                      rowData.cargaDoc.docCargaDoc.doc
                    "
                    @click="onEditaPartesEnv(rowData.DocFiscalPartesEnv)"
                    v-b-tooltip
                    title="Editar"
                    ><i class="fa fa-edit"></i
                  ></a>
                </td>
              </tr>
            </tbody>

            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-success">Destinatário</span>
                </td>
                <td>
                  <span v-if="rowData.DocFiscalPartesEnv.desCnpj != null">{{
                    ajustaMascara(rowData.DocFiscalPartesEnv.desCnpj)
                  }}</span>
                  <span v-if="rowData.DocFiscalPartesEnv.desCpf != null">{{
                    ajustaMascara(rowData.DocFiscalPartesEnv.desCpf)
                  }}</span>
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.desIe }}
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.desNome }}
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.desNomeMunicipio }}
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.desUf }}
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.desEndereco }} -
                  {{ rowData.DocFiscalPartesEnv.desComplemento }} -
                  {{ rowData.DocFiscalPartesEnv.desNumero }}
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.desBairro }}
                </td>
                <td>
                  <span v-if="rowData.DocFiscalPartesEnv.desCep">{{
                    rowData.DocFiscalPartesEnv.desCep
                      .toString()
                      .padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.desEmail }}
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.desTelefone }}
                </td>
                <td>
                  <a
                    v-if="
                      getPermission('montagemcarga.update') &&
                      rowData.cargaDoc &&
                      rowData.cargaDoc.docCargaDoc &&
                      rowData.cargaDoc.docCargaDoc.doc
                    "
                    @click="onEditaPartesEnv(rowData.DocFiscalPartesEnv)"
                    v-b-tooltip
                    title="Editar"
                    ><i class="fa fa-edit"></i
                  ></a>
                </td>
              </tr>
            </tbody>

            <tbody
              v-if="
                rowData.DocFiscalPartesEnv.redCnpj != null ||
                rowData.DocFiscalPartesEnv.redCpf != null
              "
            >
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span class="badge badge-info">Redespacho</span>
                </td>
                <td>
                  <span v-if="rowData.DocFiscalPartesEnv.redCnpj != null">{{
                    ajustaMascara(rowData.DocFiscalPartesEnv.redCnpj)
                  }}</span>
                  <span v-if="rowData.DocFiscalPartesEnv.redCpf != null">{{
                    ajustaMascara(rowData.DocFiscalPartesEnv.redCpf)
                  }}</span>
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.redIe }}
                </td>
                <td>
                  <span v-if="rowData.DocFiscalPartesEnv.redNome != null">{{
                    rowData.DocFiscalPartesEnv.redNome
                  }}</span>
                </td>
                <td>
                  <span
                    v-if="
                      rowData.DocFiscalPartesEnv.redNomeMunicipio != null
                    "
                    >{{
                      rowData.DocFiscalPartesEnv.redNomeMunicipio
                    }}</span
                  >
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.redUf }}
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.redEndereco }}
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.redBairro }}
                </td>
                <td>
                  <span v-if="rowData.DocFiscalPartesEnv.redCep">{{
                    rowData.DocFiscalPartesEnv.redCep
                      .toString()
                      .padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.redEmail }}
                </td>
                <td>
                  {{ rowData.DocFiscalPartesEnv.redTelefone }}
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          :class="{ 'active show': isActive('#t2' + rowData.docfisId + '') }"
          v-bind:id="'#t2' + rowData.docfisId + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Código</th>
                <th style="width: 45%">Descrição</th>
                <th style="width: 5%">NCM</th>
                <th style="width: 5%">CFOP</th>
                <th style="width: 5%">Uid. Med.</th>
                <th style="width: 5%">Qtde.</th>
                <th style="width: 5%">Peso Bruto</th>
                <th style="width: 5%">Peso Liquído</th>
                <th style="width: 5%">Volume</th>
                <th style="width: 5%">Vlr. Item</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.docFiscalProduto"
              >
                <td>
                  {{ item.cdProduto }}
                </td>
                <td>
                  {{ item.descrProduto }}
                </td>
                <td>
                  {{ item.ncm }}
                </td>
                <td>
                  {{ item.cfop }}
                </td>
                <td>
                  {{ item.unidadeComercial }}
                </td>
                <td>
                  {{ formatNumber(item.qtdeComercial) }}
                </td>
                <td>
                  {{ formatNumber(item.vlrBruto) }}
                </td>
                <td></td>
                <td></td>
                <td>
                  {{ formatNumber(item.vlrUnitario) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          :class="{ 'active show': isActive('#t3' + rowData.docfisId + '') }"
          v-bind:id="'#t3' + rowData.docfisId + ''"
          v-if="rowData.docFiscalUnidade.length > 0"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">Código</th>
                <th style="width: 90%">Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.docFiscalUnidade"
              >
                <td>
                  {{ item.cd }}
                </td>
                <td>
                  {{ item.descr }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->

        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          :class="{ 'active show': isActive('#t4' + rowData.docfisId + '') }"
          v-bind:id="'#t4' + rowData.docfisId + ''"
          v-if="
            rowData.cargaBipDoc != null &&
            rowData.cargaBipDoc.carga != null &&
            rowData.cargaBipDoc.carga.obs != null
          "
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 10%">Observação</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  {{ rowData.cargaBipDoc.carga.obs }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
      <MontagemCargaPartesEnvForm ref="montagemcargapartesenv">
      </MontagemCargaPartesEnvForm>
    </div>
  </div>
</template>
<script>
import accounting from "accounting";
import MontagemCargaPartesEnvForm from "./MontagemCargaPartesEnvForm";

export default {
  components: {
    MontagemCargaPartesEnvForm,
  },
  data() {
    return {
      abaAtiva: "",
      helpForm: new Form({ statusRecord: [], params: [] }),
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  mounted() {
    this.$parent.visibleDetailRows.forEach((item, i) => {
      this.abaAtiva = "#t1" + item + "";
    });
  },
  methods: {
    isActive(aba) {
      return this.abaAtiva === aba;
    },
    setActive(aba) {
      this.abaAtiva = aba;
    },
    onEditaPartesEnv(data) {
      this.$refs.montagemcargapartesenv.onEdit(data);
    },
    ajustaMascara(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
            /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
            "$1.$2.$3/$4-$5"
          );
        }
      }
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
};
</script>
